import React, { ReactNode } from "react";

interface Props {
  leftButton: ReactNode;
  rightButton: ReactNode;
}

export default function (props: Props) {
  return (
    <div className="d-flex justify-content-end st-gap flex-grow-1">
      <div>{props.leftButton}</div>
      <div>{props.rightButton}</div>
    </div>
  );
}
